import { toastError, toastSuccess } from '@shared/plugIn/toast';

/**
 * 관리자 확인용(비기록) 미리보기 링크.
 * secretKey 쿼리를 붙이면 수신자 열람/조회 기록을 남기지 않고 페이지가 정상 동작하는지
 * 확인할 수 있다. (GiftStoreAuthGate / GiftCouponRedeemPage 가 이 키를 검증)
 *
 * 예: http://localhost:3000/gift-store/coupon/265A28?secretKey=...
 */
export const buildAdminPreviewLink = (
  kind: 'coupon' | 'delivery',
  code: string,
): string =>
  `${window.location.origin}/gift-store/${kind}/${code}?secretKey=${encodeURIComponent(
    process.env.REACT_APP_GIFT_STORE_ADMIN_PREVIEW_KEY ?? '',
  )}`;

/** 관리자 확인용 링크를 클립보드에 복사하고 토스트로 결과를 안내한다. */
export const copyAdminPreviewLink = async (
  kind: 'coupon' | 'delivery',
  code: string,
): Promise<void> => {
  try {
    await navigator.clipboard.writeText(buildAdminPreviewLink(kind, code));
    toastSuccess('관리자 확인용 링크가 복사되었습니다.');
  } catch {
    toastError('링크 복사에 실패했습니다.');
  }
};
